// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b6913e48","147":"5961d603","210":"bf771163","807":"66ea1a9b","899":"3fe0f1bd","900":"bbec8e99","996":"b3d8b595"}[chunkId] + ".chunk.js";
};